import { api } from '../../shared/lib/api';
import type {
  Categoria,
  CategoriaInput,
  GrupoComplementos,
  GrupoInput,
  Produto,
  ProdutoInput,
} from './types';

export interface ProdutoFilters {
  q?: string;
  categoria_id?: string;
  ativo?: boolean;
  codigo_barras?: string;
}

export const catalogoApi = {
  // categorias
  listCategorias: (ativo?: boolean) =>
    api.get<Categoria[]>('catalogo/categorias', ativo === undefined ? undefined : { ativo }),
  createCategoria: (body: CategoriaInput) =>
    api.post<Categoria>('catalogo/categorias', body),
  updateCategoria: (id: string, body: Partial<CategoriaInput>) =>
    api.patch<Categoria>(`catalogo/categorias/${id}`, body),
  deleteCategoria: (id: string) =>
    api.delete<{ id: string }>(`catalogo/categorias/${id}`),

  // produtos
  listProdutos: (filters: ProdutoFilters = {}) =>
    api.get<Produto[]>('catalogo/produtos', filters as Record<string, unknown>),
  getProduto: (id: string) => api.get<Produto>(`catalogo/produtos/${id}`),
  createProduto: (body: ProdutoInput) => api.post<Produto>('catalogo/produtos', body),
  updateProduto: (id: string, body: Partial<ProdutoInput>) =>
    api.patch<Produto>(`catalogo/produtos/${id}`, body),
  deleteProduto: (id: string) =>
    api.delete<{ id: string }>(`catalogo/produtos/${id}`),

  // grupos
  listGrupos: (ativo?: boolean) =>
    api.get<GrupoComplementos[]>(
      'catalogo/grupos-complementos',
      ativo === undefined ? undefined : { ativo },
    ),
  createGrupo: (body: GrupoInput) =>
    api.post<GrupoComplementos>('catalogo/grupos-complementos', body),
  updateGrupo: (id: string, body: Partial<GrupoInput>) =>
    api.patch<GrupoComplementos>(`catalogo/grupos-complementos/${id}`, body),
  deleteGrupo: (id: string) =>
    api.delete<{ id: string }>(`catalogo/grupos-complementos/${id}`),
};
